import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import cx from 'classnames';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { darken, fade } from '@material-ui/core/styles/colorManipulator';
import Icon from '../Icon';
var DANGER_COLOR = 'rgb(155, 10, 10)';

var styles = function styles(theme) {
  return {
    danger: {
      '&$contained': {
        backgroundColor: DANGER_COLOR,
        color: theme.palette.getContrastText(DANGER_COLOR),
        '&:hover': {
          backgroundColor: darken(DANGER_COLOR, 0.2),
          color: theme.palette.getContrastText(DANGER_COLOR)
        }
      },
      '&$outlined, &$text': {
        color: DANGER_COLOR,
        borderColor: DANGER_COLOR,
        '&:hover': {
          borderColor: darken(DANGER_COLOR, 0.3),
          color: darken(DANGER_COLOR, 0.2),
          backgroundColor: fade(DANGER_COLOR, 0.1)
        }
      },
      '&$text': {
        color: 'inherit'
      }
    },
    text: {
      minWidth: 80
    },
    outlined: {
      minWidth: 80
    },
    contained: {
      minWidth: 80
    }
  };
};
/**
 * @param {import('./types').ButtonProps} props
 */


var PrimaryButton = React.forwardRef(function (_ref, ref) {
  var _cx;

  var classes = _ref.classes,
      children = _ref.children,
      icon = _ref.icon,
      className = _ref.className,
      color = _ref.color,
      variant = _ref.variant,
      onClick = _ref.onClick,
      disablePromise = _ref.disablePromise,
      pendingPromise = _ref.pendingPromise,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["classes", "children", "icon", "className", "color", "variant", "onClick", "disablePromise", "pendingPromise", "disabled"]);

  var text = typeof children === 'string' ? children : '';
  var btnColor = 'primary';
  if (color && color !== 'danger') btnColor = color;
  var btnVariant = 'contained';
  if (variant) btnVariant = variant;
  var btnDisabled = undefined;
  if (disabled) btnDisabled = disabled;

  var _React$useState = React.useState({
    disabled: !!btnDisabled,
    children: children,
    promise: false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      crtBtn = _React$useState2[0],
      setCrtBtn = _React$useState2[1];

  var unmountRef = React.useRef(true);
  React.useEffect(function () {
    return function () {
      return unmountRef.current = false;
    };
  }, []);
  var btnOnClick = undefined;

  if (onClick) {
    if (disablePromise) {
      btnOnClick = onClick;
    } else {
      btnOnClick = function btnOnClick() {
        var returnValue = onClick.apply(void 0, arguments);

        if (returnValue && returnValue.then) {
          setCrtBtn({
            promise: true,
            disabled: true,
            children: pendingPromise || children
          });
          return returnValue.then(function (data) {
            unmountRef.current && setCrtBtn({
              promise: false,
              disabled: false,
              children: children
            });
            return data;
          }).catch(function (data) {
            unmountRef.current && setCrtBtn({
              promise: false,
              disabled: false,
              children: children
            });
            return data;
          });
        }

        return returnValue;
      };
    }
  }

  return React.createElement(Button, Object.assign({
    variant: btnVariant,
    className: cx(className, (_cx = {}, _defineProperty(_cx, classes.danger, color === 'danger'), _defineProperty(_cx, classes[btnVariant], !!btnVariant), _cx)),
    color: btnColor,
    onClick: btnOnClick,
    disabled: crtBtn.promise ? crtBtn.disabled : disabled,
    "aria-label": text,
    ref: ref
  }, rest), icon && React.createElement(Icon, {
    type: crtBtn.promise ? 'loading' : icon,
    style: {
      marginRight: 4,
      fontSize: 'inherit'
    }
  }), crtBtn.promise ? crtBtn.children : children);
});
PrimaryButton.defaultProps = {
  disablePromise: false,
  pendingPromise: null
};
/**
 * @type {React.FC<import('./types').ButtonProps>}
 */
// @ts-ignore

var PrimaryButtonExport = withStyles(styles, {
  name: 'ECPrimaryButton'
})(PrimaryButton);
export default PrimaryButtonExport;